/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const AirQualityInfoLoadingUI = () => {
    return (
        <Container>
            <IconInfoTextLoadingWrapper>
                <Circle>
                    <AnimatedLoadingPlaceholder width={32} height='32px' radius={16} />
                </Circle>
                <InfoTextLoadingUI>
                    <AnimatedLoadingPlaceholder />
                </InfoTextLoadingUI>
            </IconInfoTextLoadingWrapper>
            <InfoTextLoadingUI isSubTextLoadingUI>
                <AnimatedLoadingPlaceholder />
            </InfoTextLoadingUI>
            <InfoTextLoadingUI isSubTextLoadingUI>
                <AnimatedLoadingPlaceholder />
            </InfoTextLoadingUI>
        </Container>
    );
};

AirQualityInfoLoadingUI.displayName = 'AirQualityInfoLoadingUI';

const Circle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 76px;
    padding: 12px 8px;
`;

interface InfoTextLoadingUIProps {
    isSubTextLoadingUI?: boolean;
}
const InfoTextLoadingUI = styled.div<InfoTextLoadingUIProps>`
    display: flex;
    flex-direction: row;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 80px;
    ${({ isSubTextLoadingUI }) => isSubTextLoadingUI && `
        width: 75%;
        margin: 5px 0 0 42px;
    `};
`;

const IconInfoTextLoadingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 121px;
    height: 100%;
`;
